











































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { List } from 'linqts'
import moment from "moment";
import QrcodeVue from 'qrcode.vue';

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import GenericService from '@/services/GenericService';
import GenericStore from '@/services/GenericStore';
import { authService } from '@/services/AuthService';

import { Sorteo } from '@/model/Sorteo';
import { DecimoService } from '@/services/DecimoService';
import { Decimo } from '@/model/Decimo';
import { Filtro } from '@/model/Filtro';
import SorteoFiltrosPopup from './SorteoFiltrosPopup.vue';
import { FiltroService } from '@/services/FiltroService';


@Component({
  components: {
    SorteoFiltrosPopup,
    QrcodeVue
  },
})
export default class SorteoNumerosDisponibles extends Vue {
  isAdmin: any;

  decimoService: any | DecimoService = new DecimoService();
  filtroService: any | FiltroService = new FiltroService();

  @Prop({ type: Number, default: 0 })
  idSorteo!: number;

  sorteo!: Sorteo;

  @Prop()
  filtro: any | Filtro;
  visibleFiltros: boolean = false;
  nameEventCloseFiltros: string = "FiltrosFormNumerosDisponibles-Close"
  nameEventSaveFiltros: string = "FiltrosFormNumerosDisponibles-Save"

  decimos: Array<Decimo> | any = [];

  filtrar: boolean = false;

  updating: boolean = false;
  loadMore: boolean = true;

  visibleQR: boolean = false;
  decimoQR: Decimo | any = {};
  indexQR: number = -1;
  textoQR: string = "";

  updateContent(){
    let self = this;
    if(!self.updating && this.idSorteo > 0){
      self.updating = true;
      this.decimoService.disponibles(this.idSorteo, this.filtrar).then((res: Array<Decimo>)=>{
        
        this.addToListDecimos(res);
        self.updating = false;
        this.decimoService.disponibles(this.idSorteo, this.filtrar).then((res: Array<Decimo>)=>{
          this.addToListDecimos(res);
        })
      })
    }
  };

  created(){
    this.loadMore = true;
    this.isAdmin = authService.isAdmin();

    eventService.on("NumerosDisponibles-Refresh", (res: Sorteo) =>{
      this.load();
    });

    eventService.on(this.nameEventCloseFiltros, (obj: any) => {
      this.visibleFiltros = false;
    });

    eventService.on("SorteoDetailLoaded", (obj: any) => {
      this.sorteo = obj;
    });

    eventService.on(this.nameEventSaveFiltros, (obj: any) => {
      this.visibleFiltros = false;
      eventService.emit("LoadPanel", true);
      this.filtroService.update(obj).then(() => {
        eventService.emit("LoadPanel", false);
        logService.Info("Filtros de números modificados correctamente - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - created()");
        toastService.success("Filtros de números modificados correctamente.");
        this.load();
      });
    });
    this.load();
  }

  destroyed(){
    eventService.off(this.nameEventCloseFiltros);
    eventService.off(this.nameEventSaveFiltros);
    eventService.off("NumerosDisponibles-Refresh");
    eventService.off("SorteoDetailLoaded");
    this.loadMore = false;
  }

  load(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - load()");
    this.decimoService.disponibles(this.idSorteo, this.filtrar).then((res: Array<Decimo>)=>{
      this.decimos = [];
      this.addToListDecimos(res);
      this.loadBackground();
      this.loadBackground();
    })
  }
  loadBackground(){
    this.decimoService.disponibles(this.idSorteo, this.filtrar).then((res: Array<Decimo>)=>{
      this.addToListDecimos(res);
    })
  }

  onFilter(){
    this.filtrar = !this.filtrar;
    logService.Info("Inicio - Sorteo: "+this.idSorteo+" - filtrar:"+this.filtrar,"SorteoNumerosDisponibles.vue - onFilter()");
    this.load();
  }

  onViewFiltros(){
    this.visibleFiltros = true;
  }

  sacado(decimo: Decimo, index: number){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - sacado()");
    eventService.emit("LoadPanel", true);
    decimo.FechaExtraccion = new Date();
    decimo.MetodoExtraccion = "FUNCIÓN NÚMEROS DISPONIBLES";
    decimo.Sacado = true;
    decimo.Stock--;

    this.decimoService.update(decimo).then((res: Decimo) =>{
      logService.Info("Número sacado correctamente - Numero: "+decimo.Numero+" - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - sacado()");
      toastService.success("Número sacado correctamente.");
      eventService.emit("GridSacados-Refresh", true);
      this.decimos.splice(index,1);
      eventService.emit("LoadPanel", false);
      if(this.decimos.length == 0){
        this.load();
      }
    })
  }

  sacadoQR(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - sacadoQR()");
    eventService.emit("LoadPanel", true);
    this.decimoQR.FechaExtraccion = new Date();
    this.decimoQR.MetodoExtraccion = "FUNCIÓN NÚMEROS DISPONIBLES";
    this.decimoQR.Sacado = true;
    this.decimoQR.Stock--;

    this.decimoService.update(this.decimoQR).then((res: Decimo) =>{
      this.visibleQR = true;
      logService.Info("Número sacado correctamente - Numero: "+this.decimoQR.Numero+" - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - sacadoQR()");
      toastService.success("Número sacado correctamente.");
      eventService.emit("GridSacados-Refresh", true);
      this.decimos.splice(this.indexQR,1);
      this.visibleQR = false;
      eventService.emit("LoadPanel", false);
      if(this.decimos.length == 0){
        this.load();
      }
    })
  }

  sacarQR(decimo: Decimo, index: number){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - sacarQR()");

    let fechaSorteo = moment(this.sorteo.FechaCelebracion).format("DDMMMYY").replace(".","").toUpperCase();
    this.decimoQR = decimo;
    this.indexQR = index;
    this.visibleQR = true;
    this.textoQR = "P=5;S="+this.sorteo.Numero+fechaSorteo+":1;W=0;N="+decimo.Numero+";F=1;SE=1;";
  }

  noDisponible(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - noDisponible()");
    this.decimoQR.Stock = 0;

    this.decimoService.update(this.decimoQR).then((res: Decimo) =>{
      logService.Info("Número modificado correctamente - Numero: "+this.decimoQR.Numero+" - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - noDisponible()");
      toastService.success("Número modificado correctamente.");
    })
  }

  salir(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosDisponibles.vue - salir()");
    this.visibleQR = false;
  }

  addToListDecimos(decimos: Array<Decimo>){
    let actuales = new List<Decimo>(this.decimos);
    let added = 0;

    for (let i = 0; i < decimos.length; i++) {
      const element = decimos[i];

      if(element !== null && element !== undefined && !actuales.Any(x => x !== undefined && x.Numero === element.Numero)){
        actuales.Add(element);
        added++;
      }
    }
    this.decimos = actuales.ToArray();
    this.loadMore = added > 0;
  }

}
